var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar'),_c('BottomNavMenu'),_vm._v(" "),_c('div',{staticClass:"widthfull mt-3"},[_c('Slide')],1),_c('Gruplar'),_c('SepetButton'),_c('Vitrin'),_c('essen-home-extra'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }